import React, { useState } from 'react';
import { Space, Popover, Tooltip } from 'antd';
import threeDotsIcon from 'src/assets/svgs/icon-three-dots.svg';
import styles from './Panelheader.module.scss';

// Define types for the props
interface Record {
  endpoint_name?: string;
  endpoint_description?: string;
  day?: string[];
  week?: string[];
  test_name?: string;
  parameters?: string;
}

interface PanelHeaderProps {
  record: Record;
	idx: number;
  unit: string;
  onEdit: (record: Record, endptTypeID: number) => void;
  onDelete: (record: Record) => void;
  endptTypeID: number;
  datalength: number;
  isLocked: boolean;
}

const PanelHeader: React.FC<PanelHeaderProps> = ({
  record,
	idx,
  unit,
  onEdit,
  onDelete,
  endptTypeID,
  datalength,
  isLocked,
}) => {
  // State to manage which popover is visible
  const [popoverVisible, setPopoverVisible] = useState(null);

	const handleEdit = (e) => {
    e.stopPropagation(); // Optional: Stops event propagation if needed    
    onEdit(record, endptTypeID);
    setPopoverVisible(null);
  };

	const handleDelete = (e) => {
		e.stopPropagation(); // Optional: Stops event propagation if needed
		onDelete(record);
		setPopoverVisible(null);
	};
  return (
    <div className={styles.endpointPanelHeader}>
      <div>
        <Tooltip title={record.endpoint_name}>
          <span className={styles.endpointPanelTitle}>
            {record.endpoint_name
              ? record.endpoint_name.length > 30
                ? `${record.endpoint_name.substring(0, 30)}...`
                : record.endpoint_name
              : '-'}
          </span>
        </Tooltip>
        <br />
        <Tooltip title={record.endpoint_description}>
          <span className={styles.headerWordWrap}>
            {record.endpoint_description
              ? record.endpoint_description.length > 100
                ? `${record.endpoint_description.substring(0, 100)}...`
                : record.endpoint_description
              : '-'}
          </span>
        </Tooltip>
      </div>

      <div className={styles.timeframeContainer}>
        {(() => {
          const timeFrames = unit === 'Day' ? record?.day : record.week;

          if (!timeFrames || timeFrames.length === 0) {
            return '-';
          }

          return timeFrames.map((item, idx) => (
            <span key={idx} className={styles.timeframeBox}>
              {item}
              {idx < timeFrames.length - 1 ? ', ' : ''}
            </span>
          ));
        })()}
      </div>

      <div className={styles.endpointPanelTitle}>{record.test_name || '-'}</div>

      <div>
        <span className="header-word-wrap">
          {record.parameters ? record.parameters : '-'}
        </span>
      </div>
      <div>
        {!isLocked && (
          <Space size="middle">
            <Popover
              placement="bottomRight"
              trigger="click"
              className={styles.threeDots}
							content={() => (
								datalength > 0 && (
									<div className={styles.endpointActions}>
										<div className={styles.editBtn} onClick={handleEdit}>Edit</div> {/* Ensure this is clickable */}
										<div className={styles.deleteBtn} onClick={handleDelete}>
											Delete
										</div>
									</div>
								)
							)}
							visible={popoverVisible === idx}
							onVisibleChange={(visible) => setPopoverVisible(visible ? idx : null)}
            >
              <img
                src={threeDotsIcon}
                alt="actions"
                onClick={(e) => e.stopPropagation()}
              />
            </Popover>
          </Space>
        )}
      </div>
    </div>
  );
};

export default PanelHeader;